import useIsMounted from 'app/hooks/useIsMounted';
import { useMeQuery } from 'legoland-sdk/dist/experimental';
import { useRemoveUserLimitsMutation } from "../api/limitsApiHooks";
import { useState } from 'react';
import { Box, Button, Modal, useToasts } from 'tombac';
import { useUserDetails } from "../../users/UserDetailsProvider";
import { ProductModalHeader } from "./ProductModalHeader";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DeleteLimitsModal(_ref) {
  let {
    isOpen,
    product,
    onRequestClose
  } = _ref;
  const mounted = useIsMounted();
  const meQuery = useMeQuery();
  const {
    addToast
  } = useToasts();
  const editedUser = useUserDetails();
  const {
    mutateAsync: restoreDefaultLimits
  } = useRemoveUserLimitsMutation();
  const [restoring, setRestoring] = useState(false);
  const handleRestore = async () => {
    setRestoring(true);
    try {
      await restoreDefaultLimits({
        productId: product.id,
        username: editedUser.email,
        me: meQuery.data.me
      });
      addToast('Default limits are restored.', 'success');
      if (mounted) onRequestClose();
    } catch (error) {
      console.error(error);
      addToast('Limits restore failed', 'danger');
    } finally {
      if (mounted.current) {
        setRestoring(false);
      }
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "DeleteLimitsModal",
    "data-sentry-source-file": "DeleteLimitsModal.tsx",
    children: [/*#__PURE__*/_jsx(ProductModalHeader, {
      onRequestClose: onRequestClose,
      productId: product.id,
      subtitle: "CAUTION: This action removes all custom limits and restores system defaults.",
      title: "Restore default limits",
      "data-sentry-element": "ProductModalHeader",
      "data-sentry-source-file": "DeleteLimitsModal.tsx",
      "data-sentry-element": "ProductModalHeader"
    }), /*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      $pb: "3sp",
      $pr: "4sp",
      $pt: "2sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "DeleteLimitsModal.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(Button, {
        $ml: "auto",
        onClick: onRequestClose,
        type: "button",
        variant: "flat",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "DeleteLimitsModal.tsx",
        "data-sentry-element": "Button",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        $ml: "1sp",
        busy: restoring,
        disabled: !isOpen,
        onClick: handleRestore,
        type: "submit",
        variant: "primary",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "DeleteLimitsModal.tsx",
        "data-sentry-element": "Button",
        children: "Restore defaults"
      })]
    })]
  });
}